import { IoCheckbox, IoCheckboxOutline } from "react-icons/io5";
import { Button } from "reactstrap";
import { ImCheckboxUnchecked } from "react-icons/im";
import { ImCheckboxChecked } from "react-icons/im";

const CheckedInput2 = ({ iconSize, value, setValue, className }) => {
  return (
    <div
      onClick={() => setValue(!value)}
      className={`p-0 cursor-pointer  bg-transparent border-none check-input-2 ${
        value === true ? "checked" : "text-black"
      } ${className}`}
    >
      {value === true ? (
        <ImCheckboxChecked size={iconSize} />
      ) : (
        <ImCheckboxUnchecked size={iconSize} color="rgba(158, 158, 158, 1)" />
      )}
    </div>
  );
};

export default CheckedInput2;
